import React from 'react';
import { useAtomValue } from 'jotai';
import { panelsAtom } from '../atoms';
import { FrustrationSignalDashboardWrapper, FrustrationSignalWrapper } from './styled';
import Header from './Header';
import FrustrationTable from './table';
import ErrorBoundary from '../../common/Retry/ErrorBoundary';

const FrustrationSignalPanel = () => {
  const panels = useAtomValue(panelsAtom);

  return (
    <ErrorBoundary>
      <FrustrationSignalDashboardWrapper style={{ display: panels.frustration ? 'block' : 'none' }}>
        <FrustrationSignalWrapper>
          <Header />
          <FrustrationTable />
        </FrustrationSignalWrapper>
      </FrustrationSignalDashboardWrapper>
    </ErrorBoundary>
  );
};

export default FrustrationSignalPanel;
